import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import { MAIN_CHART_AREA_CLASS_NAME } from 'modules/main/constants/main-chart';
import { ChartCard } from 'shared/components/chart/chart-card';
import { twJoin } from 'tailwind-merge';
export const ChartsSkeleton = () => {
  const $ = _c(4);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-4 w-[70px] rounded-md" />;
    t1 = <Skeleton className="h-7 w-14 rounded-md" />;
    t2 = <Skeleton className="h-7 w-24 rounded-md" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ChartCard title={t0} headerAction={t1} valueAction={t2}><Skeleton className={twJoin("rounded-md", MAIN_CHART_AREA_CLASS_NAME)} /></ChartCard>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};